export class RelatorioSearchParameter {
  id: number;
  beneficiado: string;
  cpf: string;
  prestador: string;
  dataInicio: Date;
  dataFim: Date;

  constructor() {
    this.id = null;
    this.beneficiado = '';
    this.cpf = '';
    this.prestador = '';
    this.dataInicio = null;
    this.dataFim = null;
  }
}
